module.exports = __webpack_public_path__ + "assets/img/34_880_big.815bc95f.jpg";